import type { KeyboardEvent } from 'react'
import { publicAsset } from '@/components/navigation/navigationAssets'
import { ReviveAdZone } from '../ads/ReviveAdZone'

const requirementCards = [
  {
    title: 'Documento válido',
    description:
      'Lleva tu cédula de identidad o pasaporte (tambien se aceptan documentos caducados).',
    image: 'images/figma/how-to-vote/raw_image_4.jpeg',
  },
  {
    title: 'Conoce tus horarios',
    description: 'Las urnas están abiertas de 07h00 a 17h00 en todo el Ecuador.',
    image: 'images/figma/how-to-vote/raw_image_1.png',
  },
  {
    title: 'Evita sanciones',
    description:
      'La ley seca rige desde el mediodía del viernes anterior hasta el mediodía del lunes posterior.',
    image: 'images/figma/how-to-vote/raw_image_2.png',
  },
  {
    title: 'Accesibilidad',
    description:
      'Mesas preferentes para adultos mayores, embarazadas y personas con discapacidad.',
    image: 'images/figma/how-to-vote/raw_image_7.jpeg',
  },
  {
    title: 'Certificado de votación',
    description:
      'No es necesario llevarlo para votar, se entrega el nuevo documento al finalizar el sufragio.',
    image: 'images/figma/how-to-vote/raw_image_10.jpeg',
  },
  {
    title: 'No tomes fotografías',
    description:
      'No tomes fotografías de tu papeleta puedes ser sancionado con una multa si te encuentran haciendolo.',
    image: 'images/figma/how-to-vote/raw_image_3.jpeg',
  },
]

function HowToVoteTitle() {
  return (
    <h1 className="how-vote-requirements__title">
      <span>¿Qué </span>
      <mark>necesito saber</mark>
      <span> para </span>
      <strong>votar?</strong>
    </h1>
  )
}

interface HowToVoteRequirementsProps {
  variant?: 'default' | 'home'
  showAd?: boolean
}

export function HowToVoteRequirements({
  variant = 'default',
  showAd = true,
}: HowToVoteRequirementsProps = {}) {
  const firstColumn = requirementCards.slice(0, 3)
  const secondColumn = requirementCards.slice(3)

  function handleCardsKeyDown(event: KeyboardEvent<HTMLDivElement>) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return

    event.preventDefault()
    event.currentTarget.scrollBy({
      left: event.key === 'ArrowRight'
        ? event.currentTarget.clientWidth * 0.9
        : event.currentTarget.clientWidth * -0.9,
      behavior: 'smooth',
    })
  }

  return (
    <section
      className={`how-vote-requirements ${variant === 'home' ? 'how-vote-requirements--home' : ''}`}
      aria-label="Qué necesito saber para votar"
    >
      <div className="how-vote-requirements__desktop-title">
        <HowToVoteTitle />
      </div>

      <div className="how-vote-requirements__panel">
        <div className="how-vote-requirements__mobile-header">
          <img
            src={publicAsset('images/figma/how-to-vote/raw_image_5.png')}
            alt=""
            loading="eager"
            decoding="async"
          />
          <HowToVoteTitle />
        </div>

        <div
          className="how-vote-requirements__cards"
          aria-label="Requisitos para votar. Desliza horizontalmente para ver todos."
          tabIndex={0}
          onKeyDown={handleCardsKeyDown}
        >
          <div className="how-vote-requirements__column">
            {firstColumn.map((card) => (
              <RequirementCard key={card.title} {...card} />
            ))}
          </div>

          <div className="how-vote-requirements__figure" aria-hidden="true">
            <img
              src={publicAsset('images/figma/how-to-vote/raw_image_5.png')}
              alt=""
              loading="eager"
              decoding="async"
            />
          </div>

          <div className="how-vote-requirements__column">
            {secondColumn.map((card) => (
              <RequirementCard key={card.title} {...card} />
            ))}
          </div>
        </div>
      </div>
      {showAd ? <div className="w-full bg-gray-200   bg-[repeating-linear-gradient(135deg,transparent_0px,transparent_8px,rgba(0,0,0,0.04)_8px,rgba(0,0,0,0.04)_9px)]">
          <p className="mt-1 text-xs text-center text-gray-500"> Espacio Publicitario</p>
          <div className=" w-full   text-center  [&_iframe]:mx-auto  [&_iframe]:block  [&_img]:mx-auto   [&_img]:block " >
            <ReviveAdZone zoneId={2} />
         </div>
          <p className="mt-1 text-xs text-center text-gray-500"> Espacio Publicitario</p>
        </div> : null}
    </section>
    
  )
}

function RequirementCard({
  description,
  image,
  title,
}: {
  description: string
  image: string
  title: string
}) {
  return (
    <article className="how-vote-card">
      <img src={publicAsset(image)} alt="" loading="lazy" decoding="async" />
      <span>
        <strong>{title}</strong>
        <p>{description}</p>
      </span>
    </article>
  )
}
